var map = {
	"./Email.svg": 646,
	"./Group.svg": 647,
	"./Layer.svg": 648,
	"./Vector.svg": 1052,
	"./amzbootcamp.svg": 1053,
	"./android.svg": 1054,
	"./butterfly.svg": 649,
	"./certificate.svg": 1055,
	"./difficulty-english.svg": 1056,
	"./doublequote.svg": 382,
	"./down-swirly.svg": 1057,
	"./girls.svg": 650,
	"./graphic.svg": 1058,
	"./komal.svg": 1059,
	"./lang.svg": 651,
	"./language.svg": 1060,
	"./learn-python.svg": 1061,
	"./leftquote.svg": 383,
	"./linkedin.svg": 1062,
	"./livelessons.svg": 652,
	"./main_image.svg": 653,
	"./misc.svg": 1063,
	"./misce.svg": 1064,
	"./never-typed.svg": 1065,
	"./playstore.svg": 1066,
	"./python.svg": 1067,
	"./residential.svg": 1068,
	"./scale.svg": 654,
	"./scratch.svg": 1069,
	"./twitter.svg": 1070,
	"./typeing.svg": 1071,
	"./typing.svg": 1072,
	"./web-development.svg": 1073,
	"./whatsapp.svg": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 645;